<template>
    <div v-if="$can('read', 'transaction')" id="notification-setting">
        <ul class="nav nav-pills mb-3 px-3 pt-3" role="tablist">
            <li class="nav-item" style="cursor: pointer;" @click="switchTab('failed')">
                <a class="nav-link" :class="{ active: activeTab === 'failed' }" role="tab">
                    تراکنش های ناموفق
                </a>
            </li>
            <li class="nav-item" style="cursor: pointer;" @click="switchTab('non-success')">
                <a class="nav-link" :class="{ active: activeTab === 'non-success' }" role="tab">
                    تراکنش های غیر موفق
                </a>
            </li>
        </ul>

        <!-- تراکنش های ناموفق -->
        <div class="bg-white px-3 py-1" v-if="activeTab === 'failed'">
            <kt-form-section data-repeater-list="phone_numbers">
                <p style="font-size: medium;margin: 30px 0">
                    لیست شماره موبایل ها برای اعلان تراکنش های ناموفق
                </p>
                <kt-row class="mx-3 my-3 d-flex align-items-center justify-content-between">
                    <kt-col lg="4" md="4" sm="12" xs="12">
                        <kt-form-label>
                            {{ $t('label.count_of_failed_transaction') }}
                        </kt-form-label>
                        <kt-form-group>
                            <kt-input-group id="count_of_failed_transaction">
                                <kt-form-control dir="ltr" type="number" name="count_of_failed_transaction"
                                    aria-describedby="national_code-error" data-id="count_of_failed_transaction"
                                    v-model="count_of_failed_transaction">
                                </kt-form-control>
                            </kt-input-group>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" sm="12" xs="12">
                        <kt-form-label>
                            {{ $t('label.period_of_failed_transaction') }}
                        </kt-form-label>
                        <kt-form-group>
                            <kt-input-group id="period_of_failed_transaction">
                                <kt-form-control dir="ltr" type="number" name="period_of_failed_transaction"
                                    aria-describedby="national_code-error" data-id="period_of_failed_transaction"
                                    v-model="period_of_failed_transaction">
                                </kt-form-control>
                            </kt-input-group>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="2" md="2" sm="12">
                        <kt-form-group>
                            <button @click.prevent="updateCountOfFailedTransaction()"
                                class="w-100 h-100 px-2 pt-3 btn-sm btn btn-label-primary btn-bold float-right"
                                id="update_count_of_failed_transaction">
                                <i class="la la-pencil-square"></i>
                                {{ $t('btn.edit') }}
                            </button>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-form-group hor data-repeater-item v-for="(phone_number, index) in phone_numbers" :key="index"
                    class="mx-3">
                    <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                        <kt-row>
                            <kt-col lg="9" md="9" sm="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('label.mobile_number') }}
                                    </kt-form-label>
                                    <kt-input-group class="d-flex align-items-center" id="phone_number">
                                        <p style="width: 200px" v-if="phone_numbers[index].full_name">
                                            {{ phone_numbers[index].full_name }}
                                        </p>
                                        <kt-form-control width="100px" dir="ltr" disabled
                                            :name="'phone_numbers.' + index + '.number'"
                                            aria-describedby="national_code-error"
                                            :data-id="'phone_numbers.' + index + '.phone_number'"
                                            v-model="phone_numbers[index].number">
                                        </kt-form-control>
                                    </kt-input-group>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </div>
                    <div
                        class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                        <kt-form-group>
                            <a @click="deleteAccount(index)"
                                class="w-100 mt-md-3 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right my-2"
                                :id="`delete_acc_btn_${index}`">
                                <i class="la la-trash-o"></i>
                                {{ $t('btn.delete') }}
                            </a>
                        </kt-form-group>
                    </div>
                </kt-form-group>
            </kt-form-section>

            <kt-form-group hor>
                <div class="kt-input-icon kt-input-icon--left">
                    <form @submit.prevent="addAccount()" id="add_new_phone">
                        <kt-row class="d-flex align-items-center justify-content-start mx-4">
                            <kt-col lg="4" md="4" sm="12" xs="12">
                                <kt-form-label>
                                    {{ $t('label.mobile_number') }}
                                </kt-form-label>
                                <kt-form-group>
                                    <kt-input-group id="new_phone_number">
                                        <kt-form-control dir="ltr" name="new_phone_number"
                                            aria-describedby="new_phone_number-error" data-id="new_phone_number"
                                            v-model="new_phone_number">
                                        </kt-form-control>
                                    </kt-input-group>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="12" xs="12">
                                <kt-form-group>
                                    <button type="submit" id="add_phone_btn"
                                        class="w-100 h-100 px-2 pt-3 btn-sm btn btn-label-primary btn-bold float-right">
                                        <i class="la la-plus"></i>
                                        {{ $t('btn.add') }}
                                    </button>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </form>
                </div>
            </kt-form-group>
        </div>

        <!-- تراکنش های غیر موفق -->
        <div class="bg-white px-3 py-1" v-if="activeTab === 'non-success'">
            <kt-form-section data-repeater-list="non_success_phone_numbers">
                <p style="font-size: medium;margin: 30px 0">
                    لیست شماره موبایل ها برای اعلان تراکنش های غیر موفق
                </p>
                <kt-row class="mx-3 my-3 d-flex align-items-center justify-content-between">
                    <kt-col lg="4" md="4" sm="12" xs="12">
                        <kt-form-label>
                            {{ $t('label.count_of_non_success_transaction') }}
                        </kt-form-label>
                        <kt-form-group>
                            <kt-input-group id="count_of_non_success_transaction">
                                <kt-form-control dir="ltr" type="number" name="count_of_non_success_transaction"
                                    aria-describedby="national_code-error" data-id="count_of_non_success_transaction"
                                    v-model="count_of_non_success_transaction">
                                </kt-form-control>
                            </kt-input-group>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" sm="12" xs="12">
                        <kt-form-label>
                            {{ $t('label.period_of_non_success_transaction') }}
                        </kt-form-label>
                        <kt-form-group>
                            <kt-input-group id="period_of_non_success_transaction">
                                <kt-form-control dir="ltr" type="number" name="period_of_non_success_transaction"
                                    aria-describedby="national_code-error" data-id="period_of_non_success_transaction"
                                    v-model="period_of_non_success_transaction">
                                </kt-form-control>
                            </kt-input-group>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="2" md="2" sm="12">
                        <kt-form-group>
                            <button @click.prevent="updateCountOfNonSuccessTransaction()"
                                class="w-100 h-100 px-2 pt-3 btn-sm btn btn-label-primary btn-bold float-right"
                                id="update_count_of_non_success_transaction">
                                <i class="la la-pencil-square"></i>
                                {{ $t('btn.edit') }}
                            </button>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-form-group hor data-repeater-item v-for="(phone_number, index) in non_success_phone_numbers" :key="index"
                    class="mx-3">
                    <div class="kt-input-icon kt-input-icon--left col-12 col-sm-9 col-lg-10">
                        <kt-row>
                            <kt-col lg="9" md="9" sm="12" xs="12">
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('label.mobile_number') }}
                                    </kt-form-label>
                                    <kt-input-group class="d-flex align-items-center" id="ns_phone_number">
                                        <p style="width: 200px" v-if="non_success_phone_numbers[index].full_name">
                                            {{ non_success_phone_numbers[index].full_name }}
                                        </p>
                                        <kt-form-control width="100px" dir="ltr" disabled
                                            :name="'non_success_phone_numbers.' + index + '.number'"
                                            aria-describedby="national_code-error"
                                            :data-id="'non_success_phone_numbers.' + index + '.phone_number'"
                                            v-model="non_success_phone_numbers[index].number">
                                        </kt-form-control>
                                    </kt-input-group>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </div>
                    <div
                        class="col-12 col-sm-3 col-lg-2 mb-lg-5 pl-lg-3 pr-lg-3 mb-md-5 pl-md-5 pr-md-5 mb-sm-5 mt-auto mb-auto">
                        <kt-form-group>
                            <a @click="deleteNonSuccessAccount(index)"
                                class="w-100 mt-md-3 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right my-2"
                                :id="`delete_ns_acc_btn_${index}`">
                                <i class="la la-trash-o"></i>
                                {{ $t('btn.delete') }}
                            </a>
                        </kt-form-group>
                    </div>
                </kt-form-group>
            </kt-form-section>

            <kt-form-group hor>
                <div class="kt-input-icon kt-input-icon--left">
                    <form @submit.prevent="addNonSuccessAccount()" id="add_new_ns_phone">
                        <kt-row class="d-flex align-items-center justify-content-start mx-4">
                            <kt-col lg="4" md="4" sm="12" xs="12">
                                <kt-form-label>
                                    {{ $t('label.mobile_number') }}
                                </kt-form-label>
                                <kt-form-group>
                                    <kt-input-group id="new_ns_phone_number">
                                        <kt-form-control dir="ltr" name="new_ns_phone_number"
                                            aria-describedby="new_ns_phone_number-error" data-id="new_ns_phone_number"
                                            v-model="new_non_success_phone_number">
                                        </kt-form-control>
                                    </kt-input-group>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="2" md="2" sm="12" xs="12">
                                <kt-form-group>
                                    <button type="submit" id="add_ns_phone_btn"
                                        class="w-100 h-100 px-2 pt-3 btn-sm btn btn-label-primary btn-bold float-right">
                                        <i class="la la-plus"></i>
                                        {{ $t('btn.add') }}
                                    </button>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </form>
                </div>
            </kt-form-group>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from "vuex";
import { KTApp } from "@/plugins/core/app";
import { i18n } from "@/plugins/i18n";
import { transactionService } from '@/common/api.service'


export default {
    data() {
        return {
            activeTab: 'failed',
            new_phone_number: null,
            new_non_success_phone_number: null,
        }
    },
    computed: {
        ...mapGetters({
            new_count_of_failed_trs: 'transaction/count_of_failed_transaction',
            new_period_of_failed_trs: 'transaction/period_of_failed_transaction',
            new_count_of_non_success_trs: 'transaction/count_of_non_success_transaction',
            new_period_of_non_success_trs: 'transaction/period_of_non_success_transaction',
        }),
        ...mapGetters('transaction', [
            'phone_numbers',
            'non_success_phone_numbers',
        ]),
        count_of_failed_transaction: {
            get() { return this.new_count_of_failed_trs },
            set(value) { this.$store.commit('transaction/setCountOfFailedTransaction', value) }
        },
        period_of_failed_transaction: {
            get() { return this.new_period_of_failed_trs },
            set(value) { this.$store.commit('transaction/setPeriodOfFailedTransaction', value) }
        },
        count_of_non_success_transaction: {
            get() { return this.new_count_of_non_success_trs },
            set(value) { this.$store.commit('transaction/setCountOfNonSuccessTransaction', value) }
        },
        period_of_non_success_transaction: {
            get() { return this.new_period_of_non_success_trs },
            set(value) { this.$store.commit('transaction/setPeriodOfNonSuccessTransaction', value) }
        },
    },
    methods: {
        switchTab(tab) {
            this.activeTab = tab
        },
        updateCountOfFailedTransaction() {
            let btn = $(`#update_count_of_failed_transaction`)

            if (!this.count_of_failed_transaction) {
                return this.toastr.error(i18n.t('deposit.message.count_of_failed_transaction_is_required'))
            }

            if (!this.period_of_failed_transaction) {
                return this.toastr.error(i18n.t('deposit.message.period_of_failed_transaction_is_required'))
            }

            KTApp.progress(btn)

            transactionService.updateCountOfFailedTransaction({
                count_of_failed_transaction: this.count_of_failed_transaction,
                period_of_failed_transaction: this.period_of_failed_transaction
            })
                .then((response) => {
                    this.toastr.success(response.data.message);
                    this.$store.dispatch('transaction/fetchTransactionNotificationSetting')
                })
                .catch(({ response }) => {
                    this.toastr.error(response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        addAccount() {
            let btn = $(`#add_phone_btn`)
            let form = $('#add_new_phone');

            form.validate({ rules: { new_phone_number: { required: true } } });

            if (!form.valid()) return

            if (!this.checkValidatePhone(this.new_phone_number)) {
                return this.toastr.error(i18n.t('deposit.message.phone_is_not_valid'))
            }

            for (let i = 0; i < this.phone_numbers.length; i++) {
                if (this.phone_numbers[i].number == this.new_phone_number) {
                    return this.toastr.error(i18n.t('transaction.message.phone_number_is_duplicate'))
                }
            }

            KTApp.progress(btn)

            let phone_numbers = this.phone_numbers.map(item => item.number)
            phone_numbers.push(this.new_phone_number)

            transactionService.updateTransactionNotificationSetting({
                phone_numbers: phone_numbers,
                new_phone_number: this.new_phone_number,
                count_of_failed_transaction: this.count_of_failed_transaction
            })
                .then((response) => {
                    this.new_phone_number = null;
                    this.$store.dispatch('transaction/fetchTransactionNotificationSetting')
                    this.toastr.success(response.data.message);
                })
                .catch(({ response }) => {
                    this.toastr.error(response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        deleteAccount(index) {
            if (confirm('آیا از حذف این آیتم اطمینان دارید؟')) {
                let btn = $('#delete_acc_btn_' + index);
                let phone_number = this.phone_numbers[index].number

                KTApp.progress(btn)

                transactionService.deletePhoneNumberInTransactionNotification(phone_number)
                    .then((response) => {
                        this.$store.dispatch('transaction/fetchTransactionNotificationSetting')
                        this.toastr.success(response.data.message);
                    })
                    .catch(({ response }) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            }
        },
        updateCountOfNonSuccessTransaction() {
            let btn = $(`#update_count_of_non_success_transaction`)

            if (!this.count_of_non_success_transaction) {
                return this.toastr.error(i18n.t('deposit.message.count_of_non_success_transaction_is_required'))
            }

            if (!this.period_of_non_success_transaction) {
                return this.toastr.error(i18n.t('deposit.message.period_of_non_success_transaction_is_required'))
            }

            KTApp.progress(btn)

            transactionService.updateCountOfNonSuccessTransaction({
                count_of_non_success_transaction: this.count_of_non_success_transaction,
                period_of_non_success_transaction: this.period_of_non_success_transaction
            })
                .then((response) => {
                    this.toastr.success(response.data.message);
                    this.$store.dispatch('transaction/fetchNonSuccessTransactionNotificationSetting')
                })
                .catch(({ response }) => {
                    this.toastr.error(response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        addNonSuccessAccount() {
            let btn = $(`#add_ns_phone_btn`)
            let form = $('#add_new_ns_phone');

            form.validate({ rules: { new_ns_phone_number: { required: true } } });

            if (!form.valid()) return

            if (!this.checkValidatePhone(this.new_non_success_phone_number)) {
                return this.toastr.error(i18n.t('deposit.message.phone_is_not_valid'))
            }

            for (let i = 0; i < this.non_success_phone_numbers.length; i++) {
                if (this.non_success_phone_numbers[i].number == this.new_non_success_phone_number) {
                    return this.toastr.error(i18n.t('transaction.message.phone_number_is_duplicate'))
                }
            }

            KTApp.progress(btn)

            let phone_numbers = this.non_success_phone_numbers.map(item => item.number)
            phone_numbers.push(this.new_non_success_phone_number)

            transactionService.updateNonSuccessTransactionNotificationSetting({
                phone_numbers: phone_numbers,
                new_phone_number: this.new_non_success_phone_number,
            })
                .then((response) => {
                    this.new_non_success_phone_number = null;
                    this.$store.dispatch('transaction/fetchNonSuccessTransactionNotificationSetting')
                    this.toastr.success(response.data.message);
                })
                .catch(({ response }) => {
                    this.toastr.error(response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        deleteNonSuccessAccount(index) {
            if (confirm('آیا از حذف این آیتم اطمینان دارید؟')) {
                let btn = $('#delete_ns_acc_btn_' + index);
                let phone_number = this.non_success_phone_numbers[index].number

                KTApp.progress(btn)

                transactionService.deletePhoneNumberInNonSuccessTransactionNotification(phone_number)
                    .then((response) => {
                        this.$store.dispatch('transaction/fetchNonSuccessTransactionNotificationSetting')
                        this.toastr.success(response.data.message);
                    })
                    .catch(({ response }) => {
                        this.toastr.error(response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            }
        },
    },
    mounted() {
        this.$store.dispatch('transaction/fetchTransactionNotificationSetting')
        this.$store.dispatch('transaction/fetchNonSuccessTransactionNotificationSetting')
    }
}

</script>
